import type { GlobalStateMergedState } from 'components/GlobalState/GlobalStateModel';
import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import { selectAllRoutes } from './selectAllRoutes';

export type RoutesByPath = {
  [path: string]: RoutesTreeItem & { parent: string | null };
};

const reduceRoutesByPath = (
  routes: RoutesTreeItem[],
  accMutable: RoutesByPath = {},
  parent: string | null = null,
): RoutesByPath =>
  routes.reduce<RoutesByPath>((acc, route) => {
    let path: string | undefined;
    if (route.path !== undefined) {
      path = route.path?.startsWith('/')
        ? route.path
        : `${parent ?? ''}/${route.path}`;
      acc[path] = {
        ...route,
        parent,
      };
    }
    if (route.children !== undefined) {
      reduceRoutesByPath(route.children, acc, path ?? parent);
    }
    return acc;
  }, accMutable);

export const selectAllRoutesByPath: (
  s: GlobalStateMergedState,
) => RoutesByPath = createScopedSelector(() =>
  createSelector(selectAllRoutes, (allRoutes) =>
    reduceRoutesByPath(allRoutes, {}, null),
  ),
);

export const testable = { reduceRoutesByPath };
